var customValidationMixin = {
    data: function () {
        return {
            serverErrorMessage: ''
        }
    },
    methods: {
        /**
         * Renders the server side error message into a generic block on the page
         * @param {any} data
         */
        renderErrorMessage: function (error) {
            const vm = this;
            const serverError = vm.$refs['server-error'];

            if (serverError) {
                vm.serverErrorMessage = JSON.parse(error.message);
                serverError.scrollIntoView();
            }
        }
    }
}